import { __spreadArray, __assign } from 'tslib';
import React__default from 'react';
import { KpkFilterModifierType } from '@keepeek/commons';
import { FormControl, ButtonBase, Typography } from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import DefaultIcon from '../../DefaultIcon/index.js';
import FilterWrapper from '../FilterWrapper/index.js';
import RadioList from '../RadioList/index.js';

var FilterRadioFacet = function (_a) {
    var _b, _c;
    var filter = _a.filter, className = _a.className, expandIcon = _a.expandIcon, _d = _a.defaultMaxItemsToShow, defaultMaxItemsToShow = _d === void 0 ? 10 : _d, onFilterUpdate = _a.onFilterUpdate, expanded = _a.expanded, setExpanded = _a.setExpanded, sx = _a.sx, KIcon = _a.KIcon;
    var _e = React__default.useState(defaultMaxItemsToShow), maxItemsToShow = _e[0], setMaxItemsToShow = _e[1];
    var t = useTranslation("refront-components").t;
    var isItemsOverflow = filter.values && filter.values.length > maxItemsToShow && maxItemsToShow !== -1;
    var items = isItemsOverflow ? __spreadArray([], filter.values, true).splice(0, maxItemsToShow) : filter.values;
    var currentValue = (_c = (_b = filter.values) === null || _b === void 0 ? void 0 : _b.find(function (f) { return f.selected; })) === null || _c === void 0 ? void 0 : _c.id;
    if (currentValue === undefined) {
        // Need to put empty value here if undefined to keep controlled input
        currentValue = "";
    }
    function handleChange(value) {
        var _a;
        onFilterUpdate(__assign(__assign({}, filter), { modifiers: ((_a = filter.modifiers) === null || _a === void 0 ? void 0 : _a.map(function (m) {
                return __assign(__assign({}, m), { selected: m.type === KpkFilterModifierType.ContainsOne });
            })) || null, values: filter.values.map(function (v) {
                return __assign(__assign({}, v), { selected: "".concat(v.id) === "".concat(value) });
            }) }));
    }
    function getIconComponent(iconName) {
        if (KIcon) {
            return React__default.createElement(KIcon, { sx: { fontSize: "0.9rem" }, className: iconName });
        }
        else {
            return React__default.createElement(DefaultIcon, { sx: { fontSize: "0.9rem" }, className: iconName });
        }
    }
    return (React__default.createElement(FilterWrapper, { className: clsx("FilterRadioFacet", className), filter: filter, expanded: expanded, setExpanded: setExpanded, expandIcon: expandIcon, testId: "FilterRadioFacet", sx: sx, KIcon: KIcon },
        React__default.createElement(FormControl, { sx: { width: "100%" }, component: "fieldset" },
            React__default.createElement(RadioList, { name: filter.id, label: filter.label, value: currentValue, radioListItems: items, handleChange: handleChange, sx: {
                    ".RadioList-formControlLabel": {
                        height: "25px"
                    }
                } }),
            isItemsOverflow && maxItemsToShow !== -1 && (React__default.createElement(ButtonBase, { focusRipple: true, sx: { alignSelf: "baseline", paddingTop: function (theme) { return theme.spacing(1); } }, onClick: function () { return setMaxItemsToShow(-1); } },
                getIconComponent("fa-sm fa-chevron-down"),
                React__default.createElement(Typography, { variant: "caption", noWrap: true, sx: { marginLeft: function (theme) { return theme.spacing(0.5); } } }, t("components.filter-checkbox.more.choice.label")))),
            maxItemsToShow === -1 && (React__default.createElement(ButtonBase, { focusRipple: true, sx: { alignSelf: "baseline", paddingTop: function (theme) { return theme.spacing(1); } }, onClick: function () { return setMaxItemsToShow(10); } },
                getIconComponent("fa-sm fa-chevron-up"),
                React__default.createElement(Typography, { variant: "caption", noWrap: true, sx: { marginLeft: function (theme) { return theme.spacing(0.5); } } }, t("components.filter-checkbox.less.choice.label")))))));
};

export { FilterRadioFacet as default };
//# sourceMappingURL=index.js.map
